import { Radio } from "@mui/material";
import { CustomCheckbox } from "../../CustomCheckbox";
import React from "react";
import { SharedUserRow } from "./SharedUserRow";
import { NameBlock } from "./NameBlock";
import { UserThatShareCampaign } from "../../../../types/apiTypes";
import { ShareCampaignRoles } from "../../../../types/enums";
import { useGetUserShareCampaignRoles } from "../../../../hooks";
import { ReuseTooltip } from "../../ReuseTooltip";
import { SharedUserMenu } from "./SharedUserMenu";

type Props = {
  user: UserThatShareCampaign;
  campaign_id: string;
  changeRoleHandler: (email: string, role: ShareCampaignRoles) => void;
  userEmail: string;
};

export const SharedUser = ({
  user,
  campaign_id,
  userEmail,
  changeRoleHandler,
}: Props) => {
  const { first_name, last_name, avatar_url, email, roles } = user;
  const { isOwner, isAdmin, isEditor } = useGetUserShareCampaignRoles(
    roles || [],
  );
  return (
    <>
      <SharedUserRow
        nameBlock={
          <NameBlock
            fullname={`${first_name} ${last_name}`}
            avatar_url={avatar_url}
            email={email}
            isCurrentUser={userEmail === email}
          />
        }
        editorBlock={
          <ReuseTooltip
            text={
              "Changing this option will remove editing access from the previous user."
            }
            maxWidth="200px"
          >
            <Radio
              checked={isEditor}
              onClick={() =>
                !isEditor && changeRoleHandler(email, ShareCampaignRoles.editor)
              }
            />
          </ReuseTooltip>
        }
        adminBlock={
          <ReuseTooltip
            text={
              "Admins can manage user access. Multiple users can share this role."
            }
            maxWidth="200px"
          >
            <CustomCheckbox
              disabled={isOwner}
              checked={isAdmin}
              onChange={() =>
                changeRoleHandler(email, ShareCampaignRoles.admin)
              }
            />
          </ReuseTooltip>
        }
        menuBlock={
          <SharedUserMenu
            campaign_id={campaign_id}
            user_email={email}
            isDisabled={isOwner}
          />
        }
        withBg={false}
      />
    </>
  );
};
